import AdminNavbar from './AdminNavbar'
import AdminBreadcrumb from './AdminBreadcrumb'

const AdminLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <AdminNavbar />
      <AdminBreadcrumb />
      <main className="pt-0">
        {children}
      </main>
    </div>
  )
}

export default AdminLayout
